import { FilterNames } from "../enums/FilterNames";
import { HttpMethods } from "../enums/HttpMethods";
import { BaseFilterTypeOption } from "../interfaces/BaseFilterTypeOption";
import { DataWrapper } from "../interfaces/DataWrapper";
import { FilterOption } from "../interfaces/FilterOption";
import ContentFeedService from "./contentFeed.service";

const filterableOptions = '?filters[isFilterable][$eq]=true'

class FiltersService {
  public static getOptionsByFilterName(filterName: FilterNames): Promise<FilterOption[]> {
    return ContentFeedService.sendRequest<void>(HttpMethods.GET, FilterNames.TYPE !== filterName ? `${filterName}${filterableOptions}` : filterName)
      .then((options: DataWrapper<BaseFilterTypeOption[]>) => {
        return options.data.map((filter) => ({
          id: filter.id,
          name: filter.attributes.name,
        }
        ));
      })
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default FiltersService;
